/**
 * The screen after a link is sent.
 *
 * It names the address back, because the commonest reason a link never arrives
 * is that it went somewhere else, and a typo is invisible once the field has
 * been cleared. It does not claim the address exists -- the API deliberately
 * will not say -- so the wording is about what was sent, not about who has an
 * account.
 */
export function CheckYourEmail({
  email,
  onStartOver,
}: {
  email: string;
  onStartOver: () => void;
}): React.JSX.Element {
  return (
    <main className="screen">
      <div className="pane">
        <header className="pane__head">
          <span className="mark" aria-hidden="true">
            SFC
          </span>
          <h1>Check your email</h1>
          <p className="lede">
            If <strong data-testid="sent-to">{email}</strong> can be signed in, a link is on its way.
            It works once and lasts twenty minutes.
          </p>
        </header>

        <p className="fine">
          Nothing arriving? It may be in spam, or the address may have a typo in it.
        </p>

        <button className="button" type="button" onClick={onStartOver}>
          Use a different address
        </button>
      </div>
    </main>
  );
}
